import React from 'react';
import './scss/aboutbackapp.scss';
import backappImage from '../../../assets/images/landing/aboutbackapp/balance-8-columns.png';

const AboutBackApp = () => {
  return (
    <section id="aboutbackapp" className="aboutbackapp-section">
      {/* Bloque 1: Blanco */}
      <div className="aboutbackapp-intro">
        <h2>¿Qué es <span className="highlight">BackApp Chile</span>?</h2>
        <p>
          Somos un <span className="highlight-2">partner</span> estratégico en gestión empresarial. 
          En <span className="highlight">BackApp</span> ofrecemos soluciones integrales para <span className="highlight-2">PYMEs</span> chilenas.
        </p>
        <p>
          Nuestro propósito es liberar a las empresas de sus procesos operativos para que puedan enfocarse en crecer.
        </p>
      </div>

      {/* Imagen flotante entre secciones */}
      <div className="aboutbackapp-image">
        <img src={backappImage} alt="Balance de 8 columnas" />
      </div>

      {/* Bloque 2: Morado */}
      <div className="aboutbackapp-details">
        <h3>Tu operación en piloto automático</h3>
        <h4>Asistencia real, siempre disponible</h4>
        <p>
          Nos encargamos de las tareas críticas y repetitivas que consumen tu tiempo. <br />
          Con BackApp, tienes más que un proveedor: tienes un equipo que te entiende y te apoya.
        </p>
      </div>
    </section>
  );
};

export default AboutBackApp;